const DOMAIN = 'cobranded.services.userSettings.privateArea.downloadAppSKModal.downloadApp.';

const TITLE_DOWNLOAD_APP_MODAL = `${DOMAIN}title`,
  DESCRIPTION_MOBILE_DOWNLOAD_APP_MODAL = `${DOMAIN}descriptionMobile`,
  DESCRIPTION_DESKTOP_DOWNLOAD_APP_MODAL = `${DOMAIN}descriptionDesktop`;

export {
  DESCRIPTION_DESKTOP_DOWNLOAD_APP_MODAL,
  DESCRIPTION_MOBILE_DOWNLOAD_APP_MODAL,
  TITLE_DOWNLOAD_APP_MODAL,
};
